import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ClipBoardService } from "../services/clipboard.service";
// import { MapsAPILoader } from '@agm/core';
import { ServerService } from "../services/server.service";
// import { AgmMap, AgmMarker } from '@agm/core';
import { Router } from "@angular/router";
import * as XLSX from 'xlsx';

// declare var google: any;
@Component({
  selector: "app-near-by",
  // changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./near-by.component.html",
  styleUrls: ["./near-by.component.scss"],
  encapsulation:ViewEncapsulation.None
})
export class NearByComponent implements OnInit {
  nearByForm: FormGroup;
  showComponentLoader = false;
  authToken = localStorage.getItem("token");
  projects: any;
  clicked = false
  showDownloadBtn = false
  displayedColumns:any = ['project','project_type','client_name','distance','price','created_at','latest_lead_created_at','lead_count']
 
  constructor(
    private fb: FormBuilder,
    // private mapsAPILoader: MapsAPILoader,
    private serverService: ServerService,
    private router: Router,
    private clipBoardService: ClipBoardService
  ) {
    this.nearByForm = this.fb.group({
      address: ["", Validators.required],
      // 'latitude':[''],
      radius: ["", Validators.required],
      project_type:[""]
      // 'longitude':['']
    });
  }

  ngOnInit() {
    // console.log(this.projects)

  }
  
  getAllProjectByRadius() {
    this.clicked = true
    if(this.nearByForm.value.address != '' && this.nearByForm.value.radius !=''){
    this.showDownloadBtn = false;
    let body = {
     'address':this.nearByForm.value.address,
      'radius':this.nearByForm.value.radius,
      'project_type':this.nearByForm.value.project_type
    };
    this.serverService.getProject(body, this.authToken).subscribe((data) => {
      // console.log(data.length)
      // console.log(data)
      if(data.length >0 ){
        this.showDownloadBtn  = true;
      }
      this.projects = data;
      this.projects = this.projects.map((item) => ({
        ...item,
        "created_at": this.formatDate(item.created_at),
        "latest_lead_created_at":this.formatDate(item.latest_lead_created_at)
      }));
      // console.log(this.projects)
    });
  }
}

  viewLeadsByProjects(project) {
    if (!project.disable) {
      sessionStorage.setItem("projectInfo", JSON.stringify(project));
      this.router.navigate([]).then((result) => {
        window.open("/page/project/leads/" + project.id, "_blank");
      });
    }
  }
  generateExcelFile() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.projects);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = 'near_by_report.xlsx';
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }
  cancel(){
    this.projects = null;
    this.clicked = false;
    this.nearByForm.reset();
    this.showDownloadBtn = false
  }
  formatDate(inputDate: string): string {
    if(inputDate != ''){
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  else{
    return '-';
  }
  }
  
}
